.choice {
  display: flex;
  flex-direction: column;
  gap: var(--zumpo-space-12);
  margin: 0;
  padding: var(--zumpo-space-24);
  border: 1px solid var(--zumpo-line);
  border-radius: var(--zumpo-radius-16);
  background: var(--zumpo-paper);
  color: var(--zumpo-ink);
  text-align: left;
  cursor: pointer;
  transition: transform 80ms ease-out;
}

/* A row: the word, and its letters at the end on the word's baseline. */
.compact {
  flex-direction: row;
  align-items: baseline;
  justify-content: space-between;
  padding: var(--zumpo-space-16) var(--zumpo-space-24);
}

.compact .word {
  flex: 1 1 auto;
  min-width: 0;
}

.compact .detail {
  flex: none;
  white-space: nowrap;
}

@media (hover: hover) {
  .choice:hover {
    border-color: var(--zumpo-ink);
    box-shadow: inset 0 0 0 1px var(--zumpo-ink);
  }
}

.choice:active {
  transform: translateY(1px);
}

.choice:focus-visible {
  outline: var(--focus-ring) solid var(--zumpo-ink);
  outline-offset: var(--focus-ring);
}

.word {
  font: var(--zumpo-text-heading);
  letter-spacing: var(--zumpo-text-heading-tracking);
}

.detail {
  color: var(--zumpo-muted);
  font: var(--zumpo-text-small);
  letter-spacing: var(--zumpo-text-small-tracking);
}

@media (prefers-reduced-motion: reduce) {
  .choice {
    transition: none;
  }

  .choice:active {
    transform: none;
  }
}
